import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField, Box, Tooltip } from '@mui/material';
import {
  AddCircleOutline as AddCircleOutlineIcon,
  HighlightOff as HighlightOffIcon,
} from '@mui/icons-material';
import { Selection } from 'components';
import { NumberFormatCustom } from 'components';

const InputItem = React.forwardRef(
  (
    { item, index, onDelete, onAdd, values, setValues, disabledField, locationVTList, unitList },
    ref,
  ) => {
    const [arrLocationVTId, setArrLocationVTId] = React.useState([]);
    const [price, setPrice] = React.useState(0);
    const [quantity, setQuantity] = React.useState(0);
    const [unitCode, setUnitCode] = React.useState('');

    React.useImperativeHandle(ref, () => ({
      getAlert() {
        alert('getAlert from Child');
      },
    }));
    React.useEffect(() => {
      setArrLocationVTId(item.arrLocationVTId || []);
      setPrice(item.price);
      setQuantity(item.quantity);
      setUnitCode(item?.unitCode);
    }, [item]);

    const onChangeLocationVT = React.useCallback(
      (e) => {
        setArrLocationVTId(e.target.value);
        setValues((prev) => {
          prev[index].arrLocationVTId = e.target.value;
          return [...prev];
        });
      },
      [arrLocationVTId],
    );

    const onChangePrice = React.useCallback(
      (e) => {
        setPrice(+e.target.value);
        setValues((prev) => {
          prev[index].price = +e.target.value;
          return [...prev];
        });
      },
      [price],
    );
    const onChangeQuantity = React.useCallback(
      (e) => {
        setQuantity(+e.target.value);
        setValues((prev) => {
          prev[index].quantity = +e.target.value;
          return [...prev];
        });
      },
      [quantity],
    );
    const onChangeUnit = React.useCallback(
      (e) => {
        setUnitCode(e.target.value);
        setValues((prev) => {
          prev[index].unitCode = e.target.value;
          return [...prev];
        });
      },
      [unitCode],
    );

    const isDisabled = !arrLocationVTId || !quantity || !price || !unitCode;

    return (
      <Container>
        <ContainerLeft>
          <Box sx={{ width: '100%', marginRight: '10px' }}>
            <Selection
              required
              sx={{
                width: '100%',
                marginTop: 0,
                fontSize: '12px',
              }}
              sxInput={{ padding: '0px', margin: '0px' }}
              label="Địa điểm vận tải"
              name="serviceId"
              onChange={onChangeLocationVT}
              value={arrLocationVTId}
              error={!arrLocationVTId}
              disabled={disabledField}
              fieldValue="id"
              fieldView="name"
              dataArrObject={locationVTList}
              multiple={true}
            />
            {!arrLocationVTId && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
        </ContainerLeft>
        <ContainerBody>
          <Box sx={{ width: '50%' }}>
            <StyledTextFieldPrice
              label="Đơn giá"
              variant="outlined"
              type="text"
              size="small"
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              onChange={onChangePrice}
              value={price}
              error={!price}
              disabled={disabledField}
            />
            {!price && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
          <Box sx={{ width: '50%' }}>
            <StyledTextFieldPrice
              label="Số lượng"
              variant="outlined"
              type="text"
              size="small"
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              onChange={onChangeQuantity}
              value={quantity}
              error={!quantity}
              disabled={disabledField}
            />
            {!quantity && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
          <Box sx={{ width: '50%' }}>
            <Selection
              required
              sx={{
                width: '100%',
                marginTop: 0,
                fontSize: '12px',
              }}
              sxInput={{ padding: '0px', margin: '0px' }}
              label="Đơn vị"
              name="serviceId"
              onChange={onChangeUnit}
              value={unitCode}
              error={!unitCode}
              disabled={disabledField}
              fieldValue="code"
              fieldView="name"
              dataArrObject={unitList}
            />
            {!unitCode && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
        </ContainerBody>
        <ContainerAction>
          {index === values.length - 1 ? (
            <>
              <Tooltip title="Xóa" arrow>
                <ButtonWrapper
                  marginBottom={isDisabled ? '15px' : '0px'}
                  onClick={() => onDelete(index)}
                  sx={{ borderColor: 'error.main' }}
                  disabled={disabledField}
                >
                  <HighlightOffIcon sx={{ color: 'error.main' }} />
                </ButtonWrapper>
              </Tooltip>
              <Tooltip title="Thêm" arrow>
                <ButtonWrapper
                  marginBottom={isDisabled ? '15px' : '0px'}
                  onClick={onAdd}
                  sx={{ borderColor: isDisabled ? 'action.disabled' : 'success.main' }}
                  disabled={isDisabled}
                >
                  <AddCircleOutlineIcon
                    sx={{ color: isDisabled ? 'action.disabled' : 'success.main' }}
                  />
                </ButtonWrapper>
              </Tooltip>
            </>
          ) : (
            <Tooltip title="Xóa" arrow>
              <ButtonWrapper
                onClick={() => onDelete(index)}
                sx={{ borderColor: 'error.main' }}
                marginBottom={isDisabled ? '15px' : '0px'}
              >
                <HighlightOffIcon sx={{ color: 'error.main' }} />
              </ButtonWrapper>
            </Tooltip>
          )}
        </ContainerAction>
      </Container>
    );
  },
);
export default InputItem;

const StyledTextFieldPrice = styled(TextField)(({ theme }) => ({
  marginRight: '10px',
  width: '95%',
}));
const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
}));
const ContainerLeft = styled(Box)(({ theme, width = '45%' }) => ({
  width: width,
  display: 'flex',
  flexDirection: 'row',
  marginTop: '5px',
}));
const ContainerBody = styled(Box)(({ theme }) => ({
  width: '50%',
  display: 'flex',
  flexDirection: 'row',
  marginTop: '5px',
}));
const ContainerAction = styled(Box)(({ theme }) => ({
  width: '5%',
  display: 'flex',
  flexDirection: 'row',
}));
const ButtonWrapper = styled(Box)(({ theme, disabled = false, marginBottom = '10px' }) => ({
  marginBottom,
  pointerEvents: disabled ? 'none' : 'all',
  paddingInline: '6px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '0 4px 4px 0',
}));
const ErrorText = styled('div')(({ theme }) => ({
  color: 'red',
  fontSize: '12px',
  marginLeft: '10px',
}));
